import { render } from "./OtherCashEditor.vue?vue&type=template&id=6aa21854&ts=true"
import script from "./OtherCashEditor.vue?vue&type=script&lang=ts"
export * from "./OtherCashEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__